import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Button, Spinner } from "react-bootstrap";
import PageTitle from "../../Components/PageTitle";
import { useTranslation } from "react-i18next";
import { getFareListById, saveFareData, updateFareData } from "../../redux/actions/FareMasterActions";
import FormInput from "../../Components/FormInput";
import { useNavigate, useParams } from "react-router-dom";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import swal from 'sweetalert2';
import Preloader from "../../Components/Preloader";

const Dashboard = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
    const [fieldErrors, setFieldErrors] = useState({});

  const [formData, setFormData] = useState({});
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth, loading, errors },
    fareMasterReducer: {
      fareLists,
      loadingFare,
      errorsFare,
      changedFareStatus,
    },
  } = useSelector((state) => state);

  useEffect(() => {
    if (id) {
      dispatch(getFareListById(auth?.accessToken, id));
    }
  }, [auth, id]);

  const [validated, setValidated] = useState(false);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    if (id) {
     const updatedData = { 
        rateType: formData.rateType,
        dayRate: Number(formData.dayRate),
        nightRate: Number(formData.nightRate),
        minimumKm: Number(formData.minimumKm),
        maximumKm: Number(formData.maximumKm)
       };
 
       
      dispatch(updateFareData(auth?.accessToken, updatedData, id));
    }
    else {
       const payload = { 
        rateType: formData.rateType,
        dayRate: Number(formData.dayRate),
        nightRate: Number(formData.nightRate),
        minimumKm: Number(formData.minimumKm),
        maximumKm: Number(formData.maximumKm)
       };
 
      dispatch(saveFareData(auth?.accessToken, payload));
    }
  };

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0) {
      if (errors?.status === 401) {
        dispatch(logout());
        toast.error(errors?.data?.message);
        navigate('/login');
        window.location.reload();
      }
    }
  }, [errors, dispatch, navigate]);

  useEffect(() => {
    if (errorsFare && Object.keys(errorsFare).length > 0) {
      if (errorsFare?.status === 409) {
        swal.fire({
          show: true,
          title: "Oops!",
          text: errorsFare?.data?.message,
          icon: "error",
          showConfirmButton: false,
          timer: 1500
        });
        dispatch({ type: 'RESET_DELETE_FARE_STATUS' });
      } else if (errorsFare?.status === 400) {
        // Handle other statusif (errorsFare?.data?.errors && Array.isArray(errorsFare.data.errors)) {
        if (errorsFare?.data?.errors && Array.isArray(errorsFare.data.errors)) {

          const transformedErrors = {};
          errorsFare.data.errors.forEach(error => {
            if (error.field && error.message) {
              transformedErrors[error.field] = error.message;
            }
          });
          setFieldErrors(transformedErrors);
        }
      } else {
        dispatch({ type: 'RESET_DELETE_FARE_STATUS' });
      }
    }
  }, [errorsFare, dispatch]);

  useEffect(() => {
    if (changedFareStatus?.message) {
      swal.fire({
        show: true,
        title: "Well done!",
        text: changedFareStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_FARE_STATUS' });
      navigate(-1);
    }
  }, [changedFareStatus, dispatch, navigate]);

  useEffect(() => {
    if (id) {
      if (fareLists && Object.keys(fareLists).length > 0) {
        setFormData({
          "rateType": fareLists?.rateType,
          "dayRate": fareLists?.dayRate,
          "nightRate": fareLists?.nightRate,
          "minimumKm": fareLists?.minimumKm,
          "maximumKm": fareLists?.maximumKm
        });
      }
    }
  }, [fareLists]);

  useEffect(() => {
    setFormData({});
    dispatch({ type: 'RESET_DELETE_FARE_STATUS' });
  }, [dispatch]);

  const inputHandler = (e) => {
    const { value, name } = e.target;
    setFormData({ ...formData, [name]: value });
    if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const inputHandlerCaps = (e) => {
    const { value, name } = e.target;
    const processedValue = value.replace(/\s+/g, '').toUpperCase(); // Remove spaces and convert to uppercase
    setFormData({ ...formData, [name]: processedValue });
    if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errors?.data?.state_code ? 'red' : base.borderColor,
      '&:hover': {
        borderColor: errors?.data?.state_code ? 'red' : base.borderColor,
      }
    }),
  };
  useEffect(() => {
      setFieldErrors({});
  },[(navigate)]);

  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: t("Fare Master"), path: "Fare-Master" },
          { label: id ? t("Update Fare Master") : t("Add Fare Master"), path: "/Add-Fare-Master", active: true },
        ]}
        title={id ? t("Update Fare Master") : t("Add Fare Master")}
      />
      <Row>
        <Col lg={3}></Col>
        <Col lg={6}>
          <Card>
            <Card.Body>
              {errorsFare?.data?.message && (
                <div className="alert alert-danger">
                  {errorsFare.data.message}
                </div>
              )}
              <Row>
                <Col lg={6}>
                  <FormInput
                    label={t("Rate Type")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.rateType}
                    name="rateType"
                    onChange={inputHandler}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={6}>
                  <FormInput
                    label={t("Day Rate")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.dayRate}
                    name="dayRate"
                    onChange={inputHandlerCaps}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={6}>
                  <FormInput
                    label={t("Night Rate")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.nightRate}
                    name="nightRate"
                    onChange={inputHandlerCaps}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={6}>
                  <FormInput
                    label={t("Minimum Km")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.minimumKm}
                    name="minimumKm"
                    onChange={inputHandlerCaps}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={6}>
                  <FormInput
                    label={t("Maximum Km")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.maximumKm}
                    name="maximumKm"
                    onChange={inputHandlerCaps}
                    containerClass={"mb-3"}
                  />
                </Col>
              </Row>

              <div className="d-flex justify-content-center">
                {loading ?
                  <Button color="primary" disabled>
                    <Spinner
                      className="spinner-border-sm me-1"
                      tag="span"
                      color="white"
                    />
                    Please wait ...
                  </Button>
                  :
                  <Button type="button" onClick={handleSubmit} disabled={loading}>
                    Submit
                  </Button>
                }
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {loadingFare && (<Preloader />)}
    </>
  );
};

export default Dashboard;
